export type SolvePanelPlacementResponseErrorCode =
    (typeof SolvePanelPlacementResponseErrorCode)[keyof typeof SolvePanelPlacementResponseErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SolvePanelPlacementResponseErrorCode = {
    None: 'None',
    ValidationFailed: 'ValidationFailed',
    InfeasiblePlacement: 'InfeasiblePlacement',
    InfeasibleGapMode: 'InfeasibleGapMode',
    LockedConflict: 'LockedConflict',
    MaterialUnavailable: 'MaterialUnavailable',
    FaultyPrefabData: 'FaultyPrefabData',
    NotImplemented: 'NotImplemented'
} as const;
